function debounce(n, t, i) {
    var r;
    return function() {
        var u = this,
            f = arguments,
            e = function() {
                r = null;
                i || n.apply(u, f)
            },
            o = i && !r;
        clearTimeout(r);
        r = setTimeout(e, t);
        o && n.apply(u, f)
    }
}

function getParameterByName(n, t) {
    t || (t = window.location.href);
    n = n.replace(/[\[\]]/g, "\\$&");
    var r = new RegExp("[?&]" + n + "(=([^&#]*)|&|#|$)"),
        i = r.exec(t);
    return i ? i[2] ? decodeURIComponent(i[2].replace(/\+/g, " ")) : "" : null
}

function detectIEEdge() {
    var n = window.navigator.userAgent,
        i = n.indexOf("MSIE "),
        u, r, t;
    return i > 0 ? parseInt(n.substring(i + 5, n.indexOf(".", i)), 10) : (u = n.indexOf("Trident/"), u > 0) ? (r = n.indexOf("rv:"), parseInt(n.substring(r + 3, n.indexOf(".", r)), 10)) : (t = n.indexOf("Edge/"), t > 0) ? parseInt(n.substring(t + 5, n.indexOf(".", t)), 10) : !1
}

function viewport() {
    var n = window,
        t = "inner";
    return "innerWidth" in window || (t = "client", n = document.documentElement || document.body), {
        width: n[t + "Width"],
        height: n[t + "Height"]
    }
}

function refineResults() {
    viewport().width < 1024 && ($(".left-filters .refine-results").hasClass("on") || $(".left-filters .refine-results").click())
}

function copyFacetToClipboard() {
    var n = $("<input>");
    $("body").append(n);
    n.val($("#FacetURL").text()).select();
    document.execCommand("copy");
    alert("Copied url: " + $("#FacetURL").text());
    n.remove()
}
var self, runResizing;
(function(n) {
    var t, r, i;
    typeof define == "function" && define.amd && (define(n), t = !0);
    typeof exports == "object" && (module.exports = n(), t = !0);
    t || (r = window.Cookies, i = window.Cookies = n(), i.noConflict = function() {
        return window.Cookies = r, i
    })
})(function() {
    function n() {
        for (var n = 0, r = {}, t, i; n < arguments.length; n++) {
            t = arguments[n];
            for (i in t) r[i] = t[i]
        }
        return r
    }

    function t(i) {
        function r(t, u, f) {
            var c, s, o, v, e, h;
            if (typeof document != "undefined") {
                if (arguments.length > 1) {
                    f = n({
                        path: "/"
                    }, r.defaults, f);
                    typeof f.expires == "number" && (f.expires = new Date(new Date * 1 + f.expires * 864e5));
                    f.expires = f.expires ? f.expires.toUTCString() : "";
                    try {
                        c = JSON.stringify(u);
                        /^[\{\[]/.test(c) && (u = c)
                    } catch (w) {}
                    u = i.write ? i.write(u, t) : encodeURIComponent(String(u)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
                    t = encodeURIComponent(String(t)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
                    s = "";
                    for (o in f) f[o] && (s += "; " + o, f[o] !== !0) && (s += "=" + f[o].split(";")[0]);
                    return document.cookie = t + "=" + u + s
                }
                for (var l = {}, y = function(n) {
                        return n.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent)
                    }, p = document.cookie ? document.cookie.split("; ") : [], a = 0; a < p.length; a++) {
                    v = p[a].split("=");
                    e = v.slice(1).join("=");
                    this.json || e.charAt(0) !== '"' || (e = e.slice(1, -1));
                    try {
                        if (h = y(v[0]), e = (i.read || i)(e, h) || y(e), this.json) try {
                            e = JSON.parse(e)
                        } catch (w) {}
                        if (l[h] = e, t === h) break
                    } catch (w) {}
                }
                return t ? l[t] : l
            }
        }
        return r.set = r, r.get = function(n) {
            return r.call(r, n)
        }, r.getJSON = function(n) {
            return r.call({
                json: !0
            }, n)
        }, r.remove = function(t, i) {
            r(t, "", n(i, {
                expires: -1
            }))
        }, r.defaults = {}, r.withConverter = t, r
    }
    return t(function() {})
});
self = this || {};
try {
    ! function(n, t) {
        if (new n("q=%2B").get("q") !== t || new n({
                q: t
            }).get("q") !== t || new n([
                ["q", t]
            ]).get("q") !== t || "q=%0A" !== new n("q=\n").toString() || "q=+%26" !== new n({
                q: " &"
            }).toString() || "q=%25zx" !== new n({
                q: "%zx"
            }).toString()) throw n;
        self.URLSearchParams = n
    }(URLSearchParams, "+")
} catch (t) {
    ! function(n, t, i) {
        "use strict";

        function s(n) {
            var o = c(null),
                h, u, t, s, l;
            switch (e(this, "_ungap", {
                value: o
            }), !0) {
                case !n:
                    break;
                case "string" == typeof n:
                    "?" === n.charAt(0) && (n = n.slice(1));
                    for (var a = n.split("&"), t = 0, s = a.length; t < s; t++) h = (u = a[t]).indexOf("="), -1 < h ? r(o, f(u.slice(0, h)), f(u.slice(h + 1))) : u.length && r(o, f(u), "");
                    break;
                case i(n):
                    for (t = 0, s = n.length; t < s; t++) r(o, (u = n[t])[0], u[1]);
                    break;
                case "forEach" in n:
                    n.forEach(p, o);
                    break;
                default:
                    for (l in n) r(o, l, n[l])
            }
        }

        function p(n, t) {
            r(this, t, n)
        }

        function r(n, t, r) {
            var u = i(r) ? r.join(",") : r;
            t in n ? n[t].push(u) : n[t] = [u]
        }

        function f(n) {
            return decodeURIComponent(n.replace(a, "%25").replace(v, " "))
        }

        function h(n) {
            return encodeURIComponent(n).replace(l, w)
        }

        function w(n) {
            return y[n]
        }
        var c = n.create,
            e = n.defineProperty,
            l = /[!'\(\)~]|%20|%00/g,
            a = /%(?![0-9a-fA-F]{2})/g,
            v = /\+/g,
            y = {
                "!": "%21",
                "'": "%27",
                "(": "%28",
                ")": "%29",
                "~": "%7E",
                "%20": "+",
                "%00": "\0"
            },
            o = {
                append: function(n, t) {
                    r(this._ungap, n, t)
                },
                "delete": function(n) {
                    delete this._ungap[n]
                },
                get: function(n) {
                    return this.has(n) ? this._ungap[n][0] : null
                },
                getAll: function(n) {
                    return this.has(n) ? this._ungap[n].slice(0) : []
                },
                has: function(n) {
                    return n in this._ungap
                },
                set: function(n, i) {
                    this._ungap[n] = [t(i)]
                },
                forEach: function(n, i) {
                    function f(f) {
                        n.call(i, f, t(r), u)
                    }
                    var u = this,
                        r;
                    for (r in u._ungap) u._ungap[r].forEach(f, r)
                },
                toJSON: function() {
                    return {}
                },
                toString: function() {
                    var i = [],
                        n;
                    for (n in this._ungap)
                        for (var u = h(n), t = 0, r = this._ungap[n]; t < r.length; t++) i.push(u + "=" + h(r[t]));
                    return i.join("&")
                }
            },
            u;
        for (u in o) e(s.prototype, u, {
            configurable: !0,
            writable: !0,
            value: o[u]
        });
        self.URLSearchParams = s
    }(Object, String, Array.isArray)
}
if (! function(n) {
        function i(n, i) {
            var r = [];
            return n.forEach(i, r), t ? r[Symbol.iterator]() : {
                next: function() {
                    var n = r.shift();
                    return {
                        done: void 0 === n,
                        value: n
                    }
                }
            }
        }
        var t = !1;
        try {
            t = !!Symbol.iterator
        } catch (i) {}
        "forEach" in n || (n.forEach = function(n, t) {
            var i = this,
                r = Object.create(null);
            this.toString().replace(/=[\s\S]*?(?:&|$)/g, "=").split("=").forEach(function(u) {
                !u.length || u in r || (r[u] = i.getAll(u)).forEach(function(r) {
                    n.call(t, r, u, i)
                })
            })
        });
        "keys" in n || (n.keys = function() {
            return i(this, function(n, t) {
                this.push(t)
            })
        });
        "values" in n || (n.values = function() {
            return i(this, function(n) {
                this.push(n)
            })
        });
        "entries" in n || (n.entries = function() {
            return i(this, function(n, t) {
                this.push([t, n])
            })
        });
        !t || Symbol.iterator in n || (n[Symbol.iterator] = n.entries);
        "sort" in n || (n.sort = function() {
                for (var n, t, f, e = this.entries(), u = e.next(), o = u.done, i = [], r = Object.create(null); !o;) t = (f = u.value)[0], i.push(t), t in r || (r[t] = []), r[t].push(f[1]), o = (u = e.next()).done;
                for (i.sort(), n = 0; n < i.length; n++) this.delete(i[n]);
                for (n = 0; n < i.length; n++) t = i[n], this.append(t, r[t].shift())
            }),
            function(t) {
                function r(t) {
                    var i = t.append;
                    t.append = n.append;
                    URLSearchParams.call(t, t._usp.search.slice(1));
                    t.append = i
                }

                function u(n, t) {
                    if (!(n instanceof t)) throw new TypeError("'searchParams' accessed on an object that does not implement interface " + t.name);
                }

                function f(f) {
                    function y(t, i) {
                        n.append.call(this, t, i);
                        t = this.toString();
                        s.set.call(this._usp, t ? "?" + t : "")
                    }

                    function p(t) {
                        n.delete.call(this, t);
                        t = this.toString();
                        s.set.call(this._usp, t ? "?" + t : "")
                    }

                    function w(t, i) {
                        n.set.call(this, t, i);
                        t = this.toString();
                        s.set.call(this._usp, t ? "?" + t : "")
                    }
                    var c, l, s, h = f.prototype,
                        v = i(h, "searchParams"),
                        a = i(h, "href"),
                        o = i(h, "search");
                    !v && o && o.set && (s = o, l = function(n, t) {
                        return n.append = y, n.delete = p, n.set = w, e(n, "_usp", {
                            configurable: !0,
                            writable: !0,
                            value: t
                        })
                    }, c = function(n, t) {
                        return e(n, "_searchParams", {
                            configurable: !0,
                            writable: !0,
                            value: l(t, n)
                        }), t
                    }, t.defineProperties(h, {
                        href: {
                            get: function() {
                                return a.get.call(this)
                            },
                            set: function(n) {
                                var t = this._searchParams;
                                a.set.call(this, n);
                                t && r(t)
                            }
                        },
                        search: {
                            get: function() {
                                return o.get.call(this)
                            },
                            set: function(n) {
                                var t = this._searchParams;
                                o.set.call(this, n);
                                t && r(t)
                            }
                        },
                        searchParams: {
                            get: function() {
                                return u(this, f), this._searchParams || c(this, new URLSearchParams(this.search.slice(1)))
                            },
                            set: function(n) {
                                u(this, f);
                                c(this, n)
                            }
                        }
                    }))
                }
                var e = t.defineProperty,
                    i = t.getOwnPropertyDescriptor;
                try {
                    f(HTMLAnchorElement);
                    /^function|object$/.test(typeof URL) && URL.prototype && f(URL)
                } catch (f) {}
            }(Object)
    }(self.URLSearchParams.prototype, Object), typeof jQuery == "undefined") throw new Error("Bootstrap's JavaScript requires jQuery"); + function(n) {
        "use strict";
        var t = n.fn.jquery.split(" ")[0].split(".");
        if (t[0] < 2 && t[1] < 9 || t[0] == 1 && t[1] == 9 && t[2] < 1 || t[0] > 3) throw new Error("Bootstrap's JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4");
    }(jQuery); + function(n) {
    "use strict";

    function i(t) {
        return n.each([{
            re: /[\xC0-\xC6]/g,
            ch: "A"
        }, {
            re: /[\xE0-\xE6]/g,
            ch: "a"
        }, {
            re: /[\xC8-\xCB]/g,
            ch: "E"
        }, {
            re: /[\xE8-\xEB]/g,
            ch: "e"
        }, {
            re: /[\xCC-\xCF]/g,
            ch: "I"
        }, {
            re: /[\xEC-\xEF]/g,
            ch: "i"
        }, {
            re: /[\xD2-\xD6]/g,
            ch: "O"
        }, {
            re: /[\xF2-\xF6]/g,
            ch: "o"
        }, {
            re: /[\xD9-\xDC]/g,
            ch: "U"
        }, {
            re: /[\xF9-\xFC]/g,
            ch: "u"
        }, {
            re: /[\xC7-\xE7]/g,
            ch: "c"
        }, {
            re: /[\xD1]/g,
            ch: "N"
        }, {
            re: /[\xF1]/g,
            ch: "n"
        }], function() {
            t = t.replace(this.re, this.ch)
        }), t
    }

    function r(n) {
        var i = {
                "&": "&amp;",
                "<": "&lt;",
                ">": "&gt;",
                '"': "&quot;",
                "'": "&#x27;",
                "`": "&#x60;"
            },
            r = "(?:" + Object.keys(i).join("|") + ")",
            u = new RegExp(r),
            f = new RegExp(r, "g"),
            t = n == null ? "" : "" + n;
        return u.test(t) ? t.replace(f, function(n) {
            return i[n]
        }) : t
    }

    function u(i, r) {
        var e = arguments,
            u = i,
            s = r,
            f, o;
        return [].shift.apply(e), o = this.each(function() {
            var o = n(this),
                i, r, c, h;
            if (o.is("select")) {
                if (i = o.data("selectpicker"), r = typeof u == "object" && u, i) {
                    if (r)
                        for (h in r) r.hasOwnProperty(h) && (i.options[h] = r[h])
                } else c = n.extend({}, t.DEFAULTS, n.fn.selectpicker.defaults || {}, o.data(), r), c.template = n.extend({}, t.DEFAULTS.template, n.fn.selectpicker.defaults ? n.fn.selectpicker.defaults.template : {}, o.data().template, r.template), o.data("selectpicker", i = new t(this, c, s));
                typeof u == "string" && (f = i[u] instanceof Function ? i[u].apply(i, e) : i.options[u])
            }
        }), typeof f != "undefined" ? f : o
    }
    var t, f;
    String.prototype.includes || function() {
        var i = {}.toString,
            n = function() {
                try {
                    var n = {},
                        t = Object.defineProperty,
                        i = t(n, n, n) && t
                } catch (r) {}
                return i
            }(),
            r = "".indexOf,
            t = function(n) {
                var u, s;
                if (this == null) throw new TypeError;
                if (u = String(this), n && i.call(n) == "[object RegExp]") throw new TypeError;
                var f = u.length,
                    e = String(n),
                    h = e.length,
                    o = arguments.length > 1 ? arguments[1] : undefined,
                    t = o ? Number(o) : 0;
                return (t != t && (t = 0), s = Math.min(Math.max(t, 0), f), h + s > f) ? !1 : r.call(u, e, t) != -1
            };
        n ? n(String.prototype, "includes", {
            value: t,
            configurable: !0,
            writable: !0
        }) : String.prototype.includes = t
    }();
    String.prototype.startsWith || function() {
        var n = function() {
                try {
                    var n = {},
                        t = Object.defineProperty,
                        i = t(n, n, n) && t
                } catch (r) {}
                return i
            }(),
            i = {}.toString,
            t = function(n) {
                var u, f, r;
                if (this == null) throw new TypeError;
                if (u = String(this), n && i.call(n) == "[object RegExp]") throw new TypeError;
                var e = u.length,
                    o = String(n),
                    s = o.length,
                    h = arguments.length > 1 ? arguments[1] : undefined,
                    t = h ? Number(h) : 0;
                if (t != t && (t = 0), f = Math.min(Math.max(t, 0), e), s + f > e) return !1;
                for (r = -1; ++r < s;)
                    if (u.charCodeAt(f + r) != o.charCodeAt(r)) return !1;
                return !0
            };
        n ? n(String.prototype, "startsWith", {
            value: t,
            configurable: !0,
            writable: !0
        }) : String.prototype.startsWith = t
    }();
    Object.keys || (Object.keys = function(n, t, i) {
        i = [];
        for (t in n) i.hasOwnProperty.call(n, t) && i.push(t);
        return i
    });
    n.fn.triggerNative = function(n) {
        var i = this[0],
            t;
        i.dispatchEvent ? (typeof Event == "function" ? t = new Event(n, {
            bubbles: !0
        }) : (t = document.createEvent("Event"), t.initEvent(n, !0, !1)), i.dispatchEvent(t)) : (i.fireEvent && (t = document.createEventObject(), t.eventType = n, i.fireEvent("on" + n, t)), this.trigger(n))
    };
    n.expr[":"].icontains = function(t, i, r) {
        var u = n(t),
            f = (u.data("tokens") || u.text()).toUpperCase();
        return f.includes(r[3].toUpperCase())
    };
    n.expr[":"].ibegins = function(t, i, r) {
        var u = n(t),
            f = (u.data("tokens") || u.text()).toUpperCase();
        return f.startsWith(r[3].toUpperCase())
    };
    n.expr[":"].aicontains = function(t, i, r) {
        var u = n(t),
            f = (u.data("tokens") || u.data("normalizedText") || u.text()).toUpperCase();
        return f.includes(r[3].toUpperCase())
    };
    n.expr[":"].aibegins = function(t, i, r) {
        var u = n(t),
            f = (u.data("tokens") || u.data("normalizedText") || u.text()).toUpperCase();
        return f.startsWith(r[3].toUpperCase())
    };
    t = function(i, r, u) {
        u && (u.stopPropagation(), u.preventDefault());
        this.$element = n(i);
        this.$newElement = null;
        this.$button = null;
        this.$menu = null;
        this.$lis = null;
        this.options = r;
        this.options.title === null && (this.options.title = this.$element.attr("title"));
        this.val = t.prototype.val;
        this.render = t.prototype.render;
        this.refresh = t.prototype.refresh;
        this.setStyle = t.prototype.setStyle;
        this.selectAll = t.prototype.selectAll;
        this.deselectAll = t.prototype.deselectAll;
        this.destroy = t.prototype.destroy;
        this.remove = t.prototype.remove;
        this.show = t.prototype.show;
        this.hide = t.prototype.hide;
        this.init()
    };
    t.VERSION = "1.10.0";
    t.DEFAULTS = {
        noneSelectedText: "Nothing selected",
        noneResultsText: "No results matched {0}",
        countSelectedText: function(n) {
            return n == 1 ? "{0} item selected" : "{0} items selected"
        },
        maxOptionsText: function(n, t) {
            return [n == 1 ? "Limit reached ({n} item max)" : "Limit reached ({n} items max)", t == 1 ? "Group limit reached ({n} item max)" : "Group limit reached ({n} items max)"]
        },
        selectAllText: "Select All",
        deselectAllText: "Deselect All",
        doneButton: !1,
        doneButtonText: "Close",
        multipleSeparator: ", ",
        styleBase: "btn",
        style: "btn-default",
        size: "auto",
        title: null,
        selectedTextFormat: "values",
        width: !1,
        container: !1,
        hideDisabled: !1,
        showSubtext: !1,
        showIcon: !0,
        showContent: !0,
        dropupAuto: !1,
        header: !1,
        liveSearch: !1,
        liveSearchPlaceholder: null,
        liveSearchNormalize: !1,
        liveSearchStyle: "contains",
        actionsBox: !1,
        iconBase: "glyphicon",
        tickIcon: "glyphicon-ok",
        showTick: !1,
        template: {
            caret: '<span class="glyphicon glyphicon-menu-down"><\/span><span class="glyphicon glyphicon-remove"><\/span>'
        },
        maxOptions: !1,
        mobile: !1,
        selectOnTab: !1,
        dropdownAlignRight: !1
    };
    t.prototype = {
        constructor: t,
        init: function() {
            var t = this,
                i = this.$element.attr("id");
            this.$element.addClass("bs-select-hidden");
            this.liObj = {};
            this.multiple = this.$element.prop("multiple");
            this.autofocus = this.$element.prop("autofocus");
            this.$newElement = this.createView();
            this.$element.after(this.$newElement).appendTo(this.$newElement);
            this.$button = this.$newElement.children("button");
            this.$menu = this.$newElement.children(".dropdown-menu");
            this.$menuInner = this.$menu.children(".inner");
            this.$searchbox = this.$menu.find("input");
            this.$element.removeClass("bs-select-hidden");
            this.options.dropdownAlignRight && this.$menu.addClass("dropdown-menu-right");
            typeof i != "undefined" && (this.$button.attr("data-id", i), n('label[for="' + i + '"]').click(function(n) {
                n.preventDefault();
                t.$button.focus()
            }));
            this.checkDisabled();
            this.clickListener();
            this.options.liveSearch && this.liveSearchListener();
            this.render();
            this.setStyle();
            this.setWidth();
            this.options.container && this.selectPosition();
            this.$menu.data("this", this);
            this.$newElement.data("this", this);
            this.options.mobile && this.mobile();
            this.$newElement.on({
                "hide.bs.dropdown": function(n) {
                    t.$element.trigger("hide.bs.select", n)
                },
                "hidden.bs.dropdown": function(n) {
                    t.$element.trigger("hidden.bs.select", n)
                },
                "show.bs.dropdown": function(n) {
                    t.$element.trigger("show.bs.select", n)
                },
                "shown.bs.dropdown": function(n) {
                    t.$element.trigger("shown.bs.select", n)
                }
            });
            if (t.$element[0].hasAttribute("required")) this.$element.on("invalid", function() {
                t.$button.addClass("bs-invalid").focus();
                t.$element.on({
                    "focus.bs.select": function() {
                        t.$button.focus();
                        t.$element.off("focus.bs.select")
                    },
                    "shown.bs.select": function() {
                        t.$element.val(t.$element.val()).off("shown.bs.select")
                    },
                    "rendered.bs.select": function() {
                        this.validity.valid && t.$button.removeClass("bs-invalid");
                        t.$element.off("rendered.bs.select")
                    }
                })
            });
            setTimeout(function() {
                t.$element.trigger("loaded.bs.select")
            })
        },
        createDropdown: function() {
            var t = this.multiple || this.options.showTick ? " show-tick" : "",
                i = this.$element.parent().hasClass("input-group") ? " input-group-btn" : "",
                u = this.autofocus ? " autofocus" : "",
                f = this.options.header ? '<div class="popover-title"><button type="button" class="close" aria-hidden="true">&times;<\/button>' + this.options.header + "<\/div>" : "",
                e = this.options.liveSearch ? '<div class="bs-searchbox"><input type="text" class="form-control" autocomplete="off"' + (null === this.options.liveSearchPlaceholder ? "" : ' placeholder="' + r(this.options.liveSearchPlaceholder) + '"') + "><\/div>" : "",
                o = this.multiple && this.options.actionsBox ? '<div class="bs-actionsbox"><div class="btn-group btn-group-sm btn-block"><button type="button" class="actions-btn bs-select-all btn btn-default">' + this.options.selectAllText + '<\/button><button type="button" class="actions-btn bs-deselect-all btn btn-default">' + this.options.deselectAllText + "<\/button><\/div><\/div>" : "",
                s = this.multiple && this.options.doneButton ? '<div class="bs-donebutton"><div class="btn-group btn-block"><button type="button" class="btn btn-sm btn-default">' + this.options.doneButtonText + "<\/button><\/div><\/div>" : "",
                h = '<div class="btn-group bootstrap-select' + t + i + '"><button type="button" class="' + this.options.styleBase + ' dropdown-toggle" data-toggle="dropdown"' + u + '><span class="filter-option pull-left"><\/span>&nbsp;<span class="bs-caret">' + this.options.template.caret + '<\/span><\/button><div class="dropdown-menu open">' + f + e + o + '<ul class="dropdown-menu inner" role="menu"><\/ul>' + s + "<\/div><\/div>";
            return n(h)
        },
        createView: function() {
            var n = this.createDropdown(),
                t = this.createLi();
            return n.find("ul")[0].innerHTML = t, n
        },
        reloadLi: function() {
            this.destroyLi();
            var n = this.createLi();
            this.$menuInner[0].innerHTML = n
        },
        destroyLi: function() {
            this.$menu.find("li").remove()
        },
        createLi: function() {
            var u = this,
                t = [],
                o = 0,
                s = document.createElement("option"),
                f = -1,
                e = function(n, t, i, r) {
                    return "<li" + (typeof i != "undefined" & "" !== i ? ' class="' + i + '"' : "") + (typeof t != "undefined" & null !== t ? ' data-original-index="' + t + '"' : "") + (typeof r != "undefined" & null !== r ? 'data-optgroup="' + r + '"' : "") + ">" + n + "<\/li>"
                },
                c = function(n, t, f, e) {
                    return '<a tabindex="0"' + (typeof t != "undefined" ? ' class="' + t + '"' : "") + (typeof f != "undefined" ? ' style="' + f + '"' : "") + (u.options.liveSearchNormalize ? ' data-normalized-text="' + i(r(n)) + '"' : "") + (typeof e != "undefined" || e !== null ? ' data-tokens="' + e + '"' : "") + ">" + n + '<span class="' + u.options.iconBase + " " + u.options.tickIcon + ' check-mark"><\/span><\/a>'
                },
                h;
            return this.options.title && !this.multiple && (f--, this.$element.find(".bs-title-option").length || (h = this.$element[0], s.className = "bs-title-option", s.appendChild(document.createTextNode(this.options.title)), s.value = "", h.insertBefore(s, h.firstChild), n(h.options[h.selectedIndex]).attr("selected") === undefined && (s.selected = !0))), this.$element.find("option").each(function(i) {
                var r = n(this),
                    w;
                if (f++, !r.hasClass("bs-title-option")) {
                    var l = this.className || "",
                        a = this.style.cssText,
                        s = r.data("content") ? r.data("content") : r.html(),
                        v = r.data("tokens") ? r.data("tokens") : null,
                        k = typeof r.data("subtext") != "undefined" ? '<small class="text-muted">' + r.data("subtext") + "<\/small>" : "",
                        h = typeof r.data("icon") != "undefined" ? '<span class="' + u.options.iconBase + " " + r.data("icon") + '"><\/span> ' : "",
                        y = this.parentNode.tagName === "OPTGROUP",
                        p = this.disabled || y && this.parentNode.disabled;
                    if (h !== "" && p && (h = "<span>" + h + "<\/span>"), u.options.hideDisabled && p && !y) {
                        f--;
                        return
                    }
                    if (r.data("content") || (s = h + '<span class="text">' + s + k + "<\/span>"), y && r.data("divider") !== !0) {
                        if (w = " " + this.parentNode.className || "", r.index() === 0) {
                            o += 1;
                            var b = this.parentNode.label,
                                d = typeof r.parent().data("subtext") != "undefined" ? '<small class="text-muted">' + r.parent().data("subtext") + "<\/small>" : "",
                                g = r.parent().data("icon") ? '<span class="' + u.options.iconBase + " " + r.parent().data("icon") + '"><\/span> ' : "";
                            b = g + '<span class="text">' + b + d + "<\/span>";
                            i !== 0 && t.length > 0 && (f++, t.push(e("", null, "divider", o + "div")));
                            f++;
                            t.push(e(b, null, "dropdown-header" + w, o))
                        }
                        if (u.options.hideDisabled && p) {
                            f--;
                            return
                        }
                        t.push(e(c(s, "opt " + l + w, a, v), i, "", o))
                    } else r.data("divider") === !0 ? t.push(e("", i, "divider")) : r.data("hidden") === !0 ? t.push(e(c(s, l, a, v), i, "hidden is-hidden")) : (this.previousElementSibling && this.previousElementSibling.tagName === "OPTGROUP" && (f++, t.push(e("", null, "divider", o + "div"))), t.push(e(c(s, l, a, v), i)));
                    u.liObj[i] = f
                }
            }), this.multiple || this.$element.find("option:selected").length !== 0 || this.options.title || this.$element.find("option").eq(0).prop("selected", !0).attr("selected", "selected"), t.join("")
        },
        findLis: function() {
            return this.$lis == null && (this.$lis = this.$menu.find("li")), this.$lis
        },
        render: function(t) {
            var i = this,
                o, r, u, f, e, s;
            t !== !1 && this.$element.find("option").each(function(n) {
                var t = i.findLis().eq(i.liObj[n]);
                i.setDisabled(n, this.disabled || this.parentNode.tagName === "OPTGROUP" && this.parentNode.disabled, t);
                i.setSelected(n, this.selected, t)
            });
            this.tabIndex();
            r = this.$element.find("option").map(function() {
                if (this.selected) {
                    if (i.options.hideDisabled && (this.disabled || this.parentNode.tagName === "OPTGROUP" && this.parentNode.disabled)) return;
                    var t = n(this),
                        u = t.data("icon") && i.options.showIcon ? '<i class="' + i.options.iconBase + " " + t.data("icon") + '"><\/i> ' : "",
                        r;
                    return r = i.options.showSubtext && t.data("subtext") && !i.multiple ? ' <small class="text-muted">' + t.data("subtext") + "<\/small>" : "", typeof t.attr("title") != "undefined" ? t.attr("title") : t.data("content") && i.options.showContent ? t.data("content") : u + t.html() + r
                }
            }).toArray();
            u = this.multiple ? r.join(this.options.multipleSeparator) : r[0];
            this.multiple && this.options.selectedTextFormat.indexOf("count") > -1 && (f = this.options.selectedTextFormat.split(">"), (f.length > 1 && r.length > f[1] || f.length == 1 && r.length >= 2) && (o = this.options.hideDisabled ? ", [disabled]" : "", e = this.$element.find("option").not('[data-divider="true"], [data-hidden="true"]' + o).length, s = typeof this.options.countSelectedText == "function" ? this.options.countSelectedText(r.length, e) : this.options.countSelectedText, u = s.replace("{0}", r.length.toString()).replace("{1}", e.toString())));
            this.options.title == undefined && (this.options.title = this.$element.attr("title"));
            this.options.selectedTextFormat == "static" && (u = this.options.title);
            u || (u = typeof this.options.title != "undefined" ? this.options.title : this.options.noneSelectedText);
            this.$button.attr("title", n.trim(u.replace(/<[^>]*>?/g, "")));
            this.$button.children(".filter-option").html(u);
            this.$element.trigger("rendered.bs.select")
        },
        setStyle: function(n, t) {
            this.$element.attr("class") && this.$newElement.addClass(this.$element.attr("class").replace(/selectpicker|mobile-device|bs-select-hidden|validate\[.*\]/gi, ""));
            var i = n ? n : this.options.style;
            t == "add" ? this.$button.addClass(i) : t == "remove" ? this.$button.removeClass(i) : (this.$button.removeClass(this.options.style), this.$button.addClass(i))
        },
        liHeight: function(t) {
            var y;
            if (t || this.options.size !== !1 && !this.sizeInfo) {
                var e = document.createElement("div"),
                    r = document.createElement("div"),
                    o = document.createElement("ul"),
                    l = document.createElement("li"),
                    p = document.createElement("li"),
                    a = document.createElement("a"),
                    v = document.createElement("span"),
                    s = this.options.header && this.$menu.find(".popover-title").length > 0 ? this.$menu.find(".popover-title")[0].cloneNode(!0) : null,
                    u = this.options.liveSearch ? document.createElement("div") : null,
                    h = this.options.actionsBox && this.multiple && this.$menu.find(".bs-actionsbox").length > 0 ? this.$menu.find(".bs-actionsbox")[0].cloneNode(!0) : null,
                    c = this.options.doneButton && this.multiple && this.$menu.find(".bs-donebutton").length > 0 ? this.$menu.find(".bs-donebutton")[0].cloneNode(!0) : null;
                v.className = "text";
                e.className = this.$menu[0].parentNode.className + " open";
                r.className = "dropdown-menu open";
                o.className = "dropdown-menu inner";
                l.className = "divider";
                v.appendChild(document.createTextNode("Inner text"));
                a.appendChild(v);
                p.appendChild(a);
                o.appendChild(p);
                o.appendChild(l);
                s && r.appendChild(s);
                u && (y = document.createElement("span"), u.className = "bs-searchbox", y.className = "form-control", u.appendChild(y), r.appendChild(u));
                h && r.appendChild(h);
                r.appendChild(o);
                c && r.appendChild(c);
                e.appendChild(r);
                document.body.appendChild(e);
                var b = a.offsetHeight,
                    k = s ? s.offsetHeight : 0,
                    d = u ? u.offsetHeight : 0,
                    g = h ? h.offsetHeight : 0,
                    nt = c ? c.offsetHeight : 0,
                    tt = n(l).outerHeight(!0),
                    i = typeof getComputedStyle == "function" ? getComputedStyle(r) : !1,
                    f = i ? null : n(r),
                    w = parseInt(i ? i.paddingTop : f.css("paddingTop")) + parseInt(i ? i.paddingBottom : f.css("paddingBottom")) + parseInt(i ? i.borderTopWidth : f.css("borderTopWidth")) + parseInt(i ? i.borderBottomWidth : f.css("borderBottomWidth")),
                    it = w + parseInt(i ? i.marginTop : f.css("marginTop")) + parseInt(i ? i.marginBottom : f.css("marginBottom")) + 2;
                document.body.removeChild(e);
                this.sizeInfo = {
                    liHeight: b,
                    headerHeight: k,
                    searchHeight: d,
                    actionsHeight: g,
                    doneButtonHeight: nt,
                    dividerHeight: tt,
                    menuPadding: w,
                    menuExtras: it
                }
            }
        },
        setSize: function() {
            var h, d, g;
            if (this.findLis(), this.liHeight(), this.options.header && this.$menu.css("padding-top", 0), this.options.size !== !1) {
                var i = this,
                    t = this.$menu,
                    p = this.$menuInner,
                    c = n(window),
                    nt = this.$newElement[0].offsetHeight,
                    w = this.sizeInfo.liHeight,
                    l = this.sizeInfo.headerHeight,
                    a = this.sizeInfo.searchHeight,
                    v = this.sizeInfo.actionsHeight,
                    y = this.sizeInfo.doneButtonHeight,
                    tt = this.sizeInfo.dividerHeight,
                    o = this.sizeInfo.menuPadding,
                    f = this.sizeInfo.menuExtras,
                    b = this.options.hideDisabled ? ".disabled" : "",
                    r, u, e, s, k = function() {
                        e = i.$newElement.offset().top - c.scrollTop();
                        s = c.height() - e - nt
                    };
                if (k(), this.options.size === "auto") {
                    h = function() {
                        var h, b = function(t, i) {
                                return function(r) {
                                    return i ? r.classList ? r.classList.contains(t) : n(r).hasClass(t) : !(r.classList ? r.classList.contains(t) : n(r).hasClass(t))
                                }
                            },
                            d = i.$menuInner[0].getElementsByTagName("li"),
                            c = Array.prototype.filter ? Array.prototype.filter.call(d, b("hidden", !1)) : i.$lis.not(".hidden"),
                            g = Array.prototype.filter ? Array.prototype.filter.call(c, b("dropdown-header", !0)) : c.filter(".dropdown-header");
                        k();
                        r = s - f;
                        i.options.container ? (t.data("height") || t.data("height", t.height()), u = t.data("height")) : u = t.height();
                        i.options.dropupAuto && i.$newElement.toggleClass("dropup", e > s && r - f < u);
                        i.$newElement.hasClass("dropup") && (r = e - f);
                        h = c.length + g.length > 3 ? w * 3 + f - 2 : 0;
                        t.css({
                            "max-height": r + "px",
                            overflow: "hidden",
                            "min-height": h + l + a + v + y + "px"
                        });
                        p.css({
                            "max-height": r - l - a - v - y - o + "px",
                            "overflow-y": "auto",
                            "min-height": Math.max(h - o, 0) + "px"
                        })
                    };
                    h();
                    this.$searchbox.off("input.getSize propertychange.getSize").on("input.getSize propertychange.getSize", h);
                    c.off("resize.getSize scroll.getSize").on("resize.getSize scroll.getSize", h)
                } else this.options.size && this.options.size != "auto" && this.$lis.not(b).length > this.options.size && (d = this.$lis.not(".divider").not(b).children().slice(0, this.options.size).last().parent().index(), g = this.$lis.slice(0, d + 1).filter(".divider").length, r = w * this.options.size + g * tt + o, i.options.container ? (t.data("height") || t.data("height", t.height()), u = t.data("height")) : u = t.height(), i.options.dropupAuto && this.$newElement.toggleClass("dropup", e > s && r - f < u), t.css({
                    "max-height": r + l + a + v + y + "px",
                    overflow: "hidden",
                    "min-height": ""
                }), p.css({
                    "max-height": r - o + "px",
                    "overflow-y": "auto",
                    "min-height": ""
                }))
            }
        },
        setWidth: function() {
            if (this.options.width === "auto") {
                this.$menu.css("min-width", "0");
                var n = this.$menu.parent().clone().appendTo("body"),
                    t = this.options.container ? this.$newElement.clone().appendTo("body") : n,
                    i = n.children(".dropdown-menu").outerWidth(),
                    r = t.css("width", "auto").children("button").outerWidth();
                n.remove();
                t.remove();
                this.$newElement.css("width", Math.max(i, r) + "px")
            } else this.options.width === "fit" ? (this.$menu.css("min-width", ""), this.$newElement.css("width", "").addClass("fit-width")) : this.options.width ? (this.$menu.css("min-width", ""), this.$newElement.css("width", this.options.width)) : (this.$menu.css("min-width", ""), this.$newElement.css("width", ""));
            this.$newElement.hasClass("fit-width") && this.options.width !== "fit" && this.$newElement.removeClass("fit-width")
        },
        selectPosition: function() {
            this.$bsContainer = n('<div class="bs-container" />');
            var t = this,
                i, r, u = function(n) {
                    t.$bsContainer.addClass(n.attr("class").replace(/form-control|fit-width/gi, "")).toggleClass("dropup", n.hasClass("dropup"));
                    i = n.offset();
                    r = n.hasClass("dropup") ? 0 : n[0].offsetHeight;
                    t.$bsContainer.css({
                        top: i.top + r,
                        left: i.left,
                        width: n[0].offsetWidth
                    })
                };
            this.$button.on("click", function() {
                var i = n(this);
                t.isDisabled() || (u(t.$newElement), t.$bsContainer.appendTo(t.options.container).toggleClass("open", !i.hasClass("open")).append(t.$menu))
            });
            n(window).on("resize scroll", function() {
                u(t.$newElement)
            });
            this.$element.on("hide.bs.select", function() {
                t.$menu.data("height", t.$menu.height());
                t.$bsContainer.detach()
            })
        },
        setSelected: function(n, t, i) {
            i || (i = this.findLis().eq(this.liObj[n]));
            i.toggleClass("selected", t)
        },
        setDisabled: function(n, t, i) {
            i || (i = this.findLis().eq(this.liObj[n]));
            t ? i.addClass("disabled").children("a").attr("href", "#").attr("tabindex", -1) : i.removeClass("disabled").children("a").removeAttr("href").attr("tabindex", 0)
        },
        isDisabled: function() {
            return this.$element[0].disabled
        },
        checkDisabled: function() {
            var n = this;
            this.isDisabled() ? (this.$newElement.addClass("disabled"), this.$button.addClass("disabled").attr("tabindex", -1)) : (this.$button.hasClass("disabled") && (this.$newElement.removeClass("disabled"), this.$button.removeClass("disabled")), this.$button.attr("tabindex") != -1 || this.$element.data("tabindex") || this.$button.removeAttr("tabindex"));
            this.$button.click(function() {
                return !n.isDisabled()
            })
        },
        tabIndex: function() {
            this.$element.data("tabindex") !== this.$element.attr("tabindex") && this.$element.attr("tabindex") !== -98 && this.$element.attr("tabindex") !== "-98" && (this.$element.data("tabindex", this.$element.attr("tabindex")), this.$button.attr("tabindex", this.$element.data("tabindex")));
            this.$element.attr("tabindex", -98)
        },
        clickListener: function() {
            var t = this,
                i = n(document);
            this.$newElement.on("touchstart.dropdown", ".dropdown-menu", function(n) {
                n.stopPropagation()
            });
            i.data("spaceSelect", !1);
            this.$button.on("keyup", function(n) {
                /(32)/.test(n.keyCode.toString(10)) && i.data("spaceSelect") && (n.preventDefault(), i.data("spaceSelect", !1))
            });
            this.$button.on("click", function() {
                t.setSize()
            });
            this.$element.on("shown.bs.select", function() {
                var i, n;
                if (t.options.liveSearch || t.multiple) {
                    if (!t.multiple) {
                        if (i = t.liObj[t.$element[0].selectedIndex], typeof i != "number" || t.options.size === !1) return;
                        n = t.$lis.eq(i)[0].offsetTop - t.$menuInner[0].offsetTop;
                        n = n - t.$menuInner[0].offsetHeight / 2 + t.sizeInfo.liHeight / 2;
                        t.$menuInner[0].scrollTop = n
                    }
                } else t.$menuInner.find(".selected a").focus()
            });
            this.$menuInner.on("click", "li a", function(i) {
                var s = n(this),
                    e = s.parent().data("originalIndex"),
                    k = t.$element.val(),
                    d = t.$element.prop("selectedIndex"),
                    v, y, b;
                if (t.multiple && i.stopPropagation(), i.preventDefault(), !t.isDisabled() && !s.parent().hasClass("disabled")) {
                    var h = t.$element.find("option"),
                        f = h.eq(e),
                        l = f.prop("selected"),
                        a = f.parent("optgroup"),
                        r = t.options.maxOptions,
                        u = a.data("maxOptions") || !1;
                    if (t.multiple) {
                        if (f.prop("selected", !l), t.setSelected(e, !l), s.blur(), (r !== !1 || u !== !1) && (v = r < h.filter(":selected").length, y = u < a.find("option:selected").length, r && v || u && y))
                            if (r && r == 1) h.prop("selected", !1), f.prop("selected", !0), t.$menuInner.find(".selected").removeClass("selected"), t.setSelected(e, !0);
                            else if (u && u == 1) a.find("option:selected").prop("selected", !1), f.prop("selected", !0), b = s.parent().data("optgroup"), t.$menuInner.find('[data-optgroup="' + b + '"]').removeClass("selected"), t.setSelected(e, !0);
                        else {
                            var o = typeof t.options.maxOptionsText == "function" ? t.options.maxOptionsText(r, u) : t.options.maxOptionsText,
                                p = o[0].replace("{n}", r),
                                w = o[1].replace("{n}", u),
                                c = n('<div class="notify"><\/div>');
                            o[2] && (p = p.replace("{var}", o[2][r > 1 ? 0 : 1]), w = w.replace("{var}", o[2][u > 1 ? 0 : 1]));
                            f.prop("selected", !1);
                            t.$menu.append(c);
                            r && v && (c.append(n("<div>" + p + "<\/div>")), t.$element.trigger("maxReached.bs.select"));
                            u && y && (c.append(n("<div>" + w + "<\/div>")), t.$element.trigger("maxReachedGrp.bs.select"));
                            setTimeout(function() {
                                t.setSelected(e, !1)
                            }, 10);
                            c.delay(750).fadeOut(300, function() {
                                n(this).remove()
                            })
                        }
                    } else h.prop("selected", !1), f.prop("selected", !0), t.$menuInner.find(".selected").removeClass("selected"), t.setSelected(e, !0);
                    t.multiple ? t.options.liveSearch && t.$searchbox.focus() : t.$button.focus();
                    (k != t.$element.val() && t.multiple || d != t.$element.prop("selectedIndex") && !t.multiple) && t.$element.trigger("changed.bs.select", [e, f.prop("selected"), l]).triggerNative("change")
                }
            });
            this.$menu.on("click", "li.disabled a, .popover-title, .popover-title :not(.close)", function(i) {
                i.currentTarget == this && (i.preventDefault(), i.stopPropagation(), t.options.liveSearch && !n(i.target).hasClass("close") ? t.$searchbox.focus() : t.$button.focus())
            });
            this.$menuInner.on("click", ".divider, .dropdown-header", function(n) {
                n.preventDefault();
                n.stopPropagation();
                t.options.liveSearch ? t.$searchbox.focus() : t.$button.focus()
            });
            this.$menu.on("click", ".popover-title .close", function() {
                t.$button.click()
            });
            this.$searchbox.on("click", function(n) {
                n.stopPropagation()
            });
            this.$menu.on("click", ".actions-btn", function(i) {
                t.options.liveSearch ? t.$searchbox.focus() : t.$button.focus();
                i.preventDefault();
                i.stopPropagation();
                n(this).hasClass("bs-select-all") ? t.selectAll() : t.deselectAll()
            });
            this.$element.change(function() {
                t.render(!1)
            })
        },
        liveSearchListener: function() {
            var t = this,
                u = n('<li class="no-results"><\/li>');
            this.$button.on("click.dropdown.data-api touchstart.dropdown.data-api", function() {
                t.$menuInner.find(".active").removeClass("active");
                !t.$searchbox.val() || (t.$searchbox.val(""), t.$lis.not(".is-hidden").removeClass("hidden"), !u.parent().length || u.remove());
                t.multiple || t.$menuInner.find(".selected").addClass("active");
                setTimeout(function() {
                    t.$searchbox.focus()
                }, 10)
            });
            this.$searchbox.on("click.dropdown.data-api focus.dropdown.data-api touchend.dropdown.data-api", function(n) {
                n.stopPropagation()
            });
            this.$searchbox.on("input propertychange", function() {
                var f, e;
                t.$searchbox.val() ? (f = t.$lis.not(".is-hidden").removeClass("hidden").children("a"), f = t.options.liveSearchNormalize ? f.not(":a" + t._searchStyle() + '("' + i(t.$searchbox.val()) + '")') : f.not(":" + t._searchStyle() + '("' + t.$searchbox.val() + '")'), f.parent().addClass("hidden"), t.$lis.filter(".dropdown-header").each(function() {
                    var i = n(this),
                        r = i.data("optgroup");
                    t.$lis.filter("[data-optgroup=" + r + "]").not(i).not(".hidden").length === 0 && (i.addClass("hidden"), t.$lis.filter("[data-optgroup=" + r + "div]").addClass("hidden"))
                }), e = t.$lis.not(".hidden"), e.each(function(t) {
                    var i = n(this);
                    i.hasClass("divider") && (i.index() === e.first().index() || i.index() === e.last().index() || e.eq(t + 1).hasClass("divider")) && i.addClass("hidden")
                }), t.$lis.not(".hidden, .no-results").length ? !u.parent().length || u.remove() : (!u.parent().length || u.remove(), u.html(t.options.noneResultsText.replace("{0}", '"' + r(t.$searchbox.val()) + '"')).show(), t.$menuInner.append(u))) : (t.$lis.not(".is-hidden").removeClass("hidden"), !u.parent().length || u.remove());
                t.$lis.filter(".active").removeClass("active");
                t.$searchbox.val() && t.$lis.not(".hidden, .divider, .dropdown-header").eq(0).addClass("active").children("a").focus();
                n(this).focus()
            })
        },
        _searchStyle: function() {
            return {
                begins: "ibegins",
                startsWith: "ibegins"
            }[this.options.liveSearchStyle] || "icontains"
        },
        val: function(n) {
            return typeof n != "undefined" ? (this.$element.val(n), this.render(), this.$element) : this.$element.val()
        },
        changeAll: function(t) {
            var i, f;
            typeof t == "undefined" && (t = !0);
            this.findLis();
            var e = this.$element.find("option"),
                u = this.$lis.not(".divider, .dropdown-header, .disabled, .hidden").toggleClass("selected", t),
                o = u.length,
                r = [];
            for (i = 0; i < o; i++) f = u[i].getAttribute("data-original-index"), r[r.length] = e.eq(f)[0];
            n(r).prop("selected", t);
            this.render(!1);
            this.$element.trigger("changed.bs.select").triggerNative("change")
        },
        selectAll: function() {
            return this.changeAll(!0)
        },
        deselectAll: function() {
            return this.changeAll(!1)
        },
        toggle: function(n) {
            n = n || window.event;
            n && n.stopPropagation();
            this.$button.trigger("click")
        },
        keydown: function(t) {
            var e = n(this),
                l = e.is("input") ? e.parent().parent() : e.parent(),
                u, r = l.data("this"),
                f, h, a, v, p, w, k, s, c = ":not(.disabled, .hidden, .dropdown-header, .divider)",
                b = {
                    32: " ",
                    48: "0",
                    49: "1",
                    50: "2",
                    51: "3",
                    52: "4",
                    53: "5",
                    54: "6",
                    55: "7",
                    56: "8",
                    57: "9",
                    59: ";",
                    65: "a",
                    66: "b",
                    67: "c",
                    68: "d",
                    69: "e",
                    70: "f",
                    71: "g",
                    72: "h",
                    73: "i",
                    74: "j",
                    75: "k",
                    76: "l",
                    77: "m",
                    78: "n",
                    79: "o",
                    80: "p",
                    81: "q",
                    82: "r",
                    83: "s",
                    84: "t",
                    85: "u",
                    86: "v",
                    87: "w",
                    88: "x",
                    89: "y",
                    90: "z",
                    96: "0",
                    97: "1",
                    98: "2",
                    99: "3",
                    100: "4",
                    101: "5",
                    102: "6",
                    103: "7",
                    104: "8",
                    105: "9"
                },
                y, o, g, d;
            (r.options.liveSearch && (l = e.parent().parent()), r.options.container && (l = r.$menu), u = n("[role=menu] li", l), s = r.$newElement.hasClass("open"), !s && (t.keyCode >= 48 && t.keyCode <= 57 || t.keyCode >= 96 && t.keyCode <= 105 || t.keyCode >= 65 && t.keyCode <= 90) && (r.options.container ? r.$button.trigger("click") : (r.setSize(), r.$menu.parent().addClass("open"), s = !0), r.$searchbox.focus()), r.options.liveSearch && (/(^9$|27)/.test(t.keyCode.toString(10)) && s && r.$menu.find(".active").length === 0 && (t.preventDefault(), r.$menu.parent().removeClass("open"), r.options.container && r.$newElement.removeClass("open"), r.$button.focus()), u = n("[role=menu] li" + c, l), e.val() || /(38|40)/.test(t.keyCode.toString(10)) || u.filter(".active").length === 0 && (u = r.$menuInner.find("li"), u = r.options.liveSearchNormalize ? u.filter(":a" + r._searchStyle() + "(" + i(b[t.keyCode]) + ")") : u.filter(":" + r._searchStyle() + "(" + b[t.keyCode] + ")"))), u.length) && (/(38|40)/.test(t.keyCode.toString(10)) ? (f = u.index(u.find("a").filter(":focus").parent()), a = u.filter(c).first().index(), v = u.filter(c).last().index(), h = u.eq(f).nextAll(c).eq(0).index(), p = u.eq(f).prevAll(c).eq(0).index(), w = u.eq(h).prevAll(c).eq(0).index(), r.options.liveSearch && (u.each(function(t) {
                n(this).hasClass("disabled") || n(this).data("index", t)
            }), f = u.index(u.filter(".active")), a = u.first().data("index"), v = u.last().data("index"), h = u.eq(f).nextAll().eq(0).data("index"), p = u.eq(f).prevAll().eq(0).data("index"), w = u.eq(h).prevAll().eq(0).data("index")), k = e.data("prevIndex"), t.keyCode == 38 ? (r.options.liveSearch && f--, f != w && f > p && (f = p), f < a && (f = a), f == k && (f = v)) : t.keyCode == 40 && (r.options.liveSearch && f++, f == -1 && (f = 0), f != w && f < h && (f = h), f > v && (f = v), f == k && (f = a)), e.data("prevIndex", f), r.options.liveSearch ? (t.preventDefault(), e.hasClass("dropdown-toggle") || (u.removeClass("active").eq(f).addClass("active").children("a").focus(), e.focus())) : u.eq(f).children("a").focus()) : e.is("input") || (y = [], u.each(function() {
                n(this).hasClass("disabled") || n.trim(n(this).children("a").text().toLowerCase()).substring(0, 1) == b[t.keyCode] && y.push(n(this).index())
            }), o = n(document).data("keycount"), o++, n(document).data("keycount", o), g = n.trim(n(":focus").text().toLowerCase()).substring(0, 1), g != b[t.keyCode] ? (o = 1, n(document).data("keycount", o)) : o >= y.length && (n(document).data("keycount", 0), o > y.length && (o = 1)), u.eq(y[o - 1]).children("a").focus()), (/(13|32)/.test(t.keyCode.toString(10)) || /(^9$)/.test(t.keyCode.toString(10)) && r.options.selectOnTab) && s && (/(32)/.test(t.keyCode.toString(10)) || t.preventDefault(), r.options.liveSearch ? /(32)/.test(t.keyCode.toString(10)) || (r.$menuInner.find(".active a").click(), e.focus()) : (d = n(":focus"), d.click(), d.focus(), t.preventDefault(), n(document).data("spaceSelect", !0)), n(document).data("keycount", 0)), (/(^9$|27)/.test(t.keyCode.toString(10)) && s && (r.multiple || r.options.liveSearch) || /(27)/.test(t.keyCode.toString(10)) && !s) && (r.$menu.parent().removeClass("open"), r.options.container && r.$newElement.removeClass("open"), r.$button.focus()))
        },
        mobile: function() {
            this.$element.addClass("mobile-device")
        },
        refresh: function() {
            this.$lis = null;
            this.liObj = {};
            this.reloadLi();
            this.render();
            this.checkDisabled();
            this.liHeight(!0);
            this.setStyle();
            this.setWidth();
            this.$lis && this.$searchbox.trigger("propertychange");
            this.$element.trigger("refreshed.bs.select")
        },
        hide: function() {
            this.$newElement.hide()
        },
        show: function() {
            this.$newElement.show()
        },
        remove: function() {
            this.$newElement.remove();
            this.$element.remove()
        },
        destroy: function() {
            this.$newElement.before(this.$element).remove();
            this.$bsContainer ? this.$bsContainer.remove() : this.$menu.remove();
            this.$element.off(".bs.select").removeData("selectpicker").removeClass("bs-select-hidden selectpicker")
        }
    };
    f = n.fn.selectpicker;
    n.fn.selectpicker = u;
    n.fn.selectpicker.Constructor = t;
    n.fn.selectpicker.noConflict = function() {
        return n.fn.selectpicker = f, this
    };
    n(document).data("keycount", 0).on("keydown.bs.select", '.bootstrap-select [data-toggle=dropdown], .bootstrap-select [role="menu"], .bs-searchbox input', t.prototype.keydown).on("focusin.modal", '.bootstrap-select [data-toggle=dropdown], .bootstrap-select [role="menu"], .bs-searchbox input', function(n) {
        n.stopPropagation()
    });
    n(window).on("load.bs.select.data-api", function() {
        n(".selectpicker").each(function() {
            var t = n(this);
            u.call(t, t.data())
        })
    })
}(jQuery),
function(n) {
    n.fn.hoverIntent = function(t, i, r) {
        var u = {
            interval: 100,
            sensitivity: 6,
            timeout: 0
        };
        u = typeof t == "object" ? n.extend(u, t) : n.isFunction(i) ? n.extend(u, {
            over: t,
            out: i,
            selector: r
        }) : n.extend(u, {
            over: t,
            out: t,
            selector: i
        });
        var f, e, o, s, h = function(n) {
                f = n.pageX;
                e = n.pageY
            },
            c = function(t, i) {
                if (i.hoverIntent_t = clearTimeout(i.hoverIntent_t), Math.sqrt((o - f) * (o - f) + (s - e) * (s - e)) < u.sensitivity) return n(i).off("mousemove.hoverIntent", h), i.hoverIntent_s = !0, u.over.apply(i, [t]);
                o = f;
                s = e;
                i.hoverIntent_t = setTimeout(function() {
                    c(t, i)
                }, u.interval)
            },
            a = function(n, t) {
                return t.hoverIntent_t = clearTimeout(t.hoverIntent_t), t.hoverIntent_s = !1, u.out.apply(t, [n])
            },
            l = function(t) {
                var r = n.extend({}, t),
                    i = this;
                if (i.hoverIntent_t && (i.hoverIntent_t = clearTimeout(i.hoverIntent_t)), t.type === "mouseenter") {
                    o = r.pageX;
                    s = r.pageY;
                    n(i).on("mousemove.hoverIntent", h);
                    i.hoverIntent_s || (i.hoverIntent_t = setTimeout(function() {
                        c(r, i)
                    }, u.interval))
                } else n(i).off("mousemove.hoverIntent", h), i.hoverIntent_s && (i.hoverIntent_t = setTimeout(function() {
                    a(r, i)
                }, u.timeout))
            };
        return this.on({
            "mouseenter.hoverIntent": l,
            "mouseleave.hoverIntent": l
        }, u.selector)
    }
}(jQuery),
function(n) {
    "use strict";
    typeof define == "function" && define.amd ? define(["jquery"], n) : typeof module != "undefined" && module.exports ? module.exports = n(require("jquery")) : n(jQuery)
}(function(n) {
    var e = -1,
        r = -1,
        i = function(n) {
            return parseFloat(n) || 0
        },
        o = function(t) {
            var f = 1,
                e = n(t),
                u = null,
                r = [];
            return e.each(function() {
                var t = n(this),
                    e = t.offset().top - i(t.css("margin-top")),
                    o = r.length > 0 ? r[r.length - 1] : null;
                o === null ? r.push(t) : Math.floor(Math.abs(u - e)) <= f ? r[r.length - 1] = o.add(t) : r.push(t);
                u = e
            }), r
        },
        u = function(t) {
            var i = {
                byRow: !0,
                property: "height",
                target: null,
                remove: !1
            };
            return typeof t == "object" ? n.extend(i, t) : (typeof t == "boolean" ? i.byRow = t : t === "remove" && (i.remove = !0), i)
        },
        t = n.fn.matchHeight = function(i) {
            var r = u(i),
                f;
            return r.remove ? (f = this, this.css(r.property, ""), n.each(t._groups, function(n, t) {
                t.elements = t.elements.not(f)
            }), this) : this.length <= 1 && !r.target ? this : (t._groups.push({
                elements: this,
                options: r
            }), t._apply(this, r), this)
        },
        f;
    t.version = "0.7.0";
    t._groups = [];
    t._throttle = 80;
    t._maintainScroll = !1;
    t._beforeUpdate = null;
    t._afterUpdate = null;
    t._rows = o;
    t._parse = i;
    t._parseOptions = u;
    t._apply = function(r, f) {
        var e = u(f),
            s = n(r),
            c = [s],
            l = n(window).scrollTop(),
            a = n("html").outerHeight(!0),
            h = s.parents().filter(":hidden");
        return h.each(function() {
            var t = n(this);
            t.data("style-cache", t.attr("style"))
        }), h.css("display", "block"), e.byRow && !e.target && (s.each(function() {
            var i = n(this),
                t = i.css("display");
            t !== "inline-block" && t !== "flex" && t !== "inline-flex" && (t = "block");
            i.data("style-cache", i.attr("style"));
            i.css({
                display: t,
                "padding-top": "0",
                "padding-bottom": "0",
                "margin-top": "0",
                "margin-bottom": "0",
                "border-top-width": "0",
                "border-bottom-width": "0",
                height: "100px",
                overflow: "hidden"
            })
        }), c = o(s), s.each(function() {
            var t = n(this);
            t.attr("style", t.data("style-cache") || "")
        })), n.each(c, function(t, r) {
            var u = n(r),
                f = 0;
            if (e.target) f = e.target.outerHeight(!1);
            else {
                if (e.byRow && u.length <= 1) {
                    u.css(e.property, "");
                    return
                }
                u.each(function() {
                    var t = n(this),
                        u = t.attr("style"),
                        i = t.css("display"),
                        r;
                    i !== "inline-block" && i !== "flex" && i !== "inline-flex" && (i = "block");
                    r = {
                        display: i
                    };
                    r[e.property] = "";
                    t.css(r);
                    t.outerHeight(!1) > f && (f = t.outerHeight(!1));
                    u ? t.attr("style", u) : t.css("display", "")
                })
            }
            u.each(function() {
                var t = n(this),
                    r = 0;
                e.target && t.is(e.target) || (t.css("box-sizing") !== "border-box" && (r += i(t.css("border-top-width")) + i(t.css("border-bottom-width")), r += i(t.css("padding-top")) + i(t.css("padding-bottom"))), t.css(e.property, f - r + "px"))
            })
        }), h.each(function() {
            var t = n(this);
            t.attr("style", t.data("style-cache") || null)
        }), t._maintainScroll && n(window).scrollTop(l / a * n("html").outerHeight(!0)), this
    };
    t._applyDataApi = function() {
        var t = {};
        n("[data-match-height], [data-mh]").each(function() {
            var i = n(this),
                r = i.attr("data-mh") || i.attr("data-match-height");
            t[r] = r in t ? t[r].add(i) : i
        });
        n.each(t, function() {
            this.matchHeight(!0)
        })
    };
    f = function(i) {
        t._beforeUpdate && t._beforeUpdate(i, t._groups);
        n.each(t._groups, function() {
            t._apply(this.elements, this.options)
        });
        t._afterUpdate && t._afterUpdate(i, t._groups)
    };
    t._update = function(i, u) {
        if (u && u.type === "resize") {
            var o = n(window).width();
            if (o === e) return;
            e = o
        }
        i ? r === -1 && (r = setTimeout(function() {
            f(u);
            r = -1
        }, t._throttle)) : f(u)
    };
    n(t._applyDataApi);
    n(window).bind("load", function(n) {
        t._update(!1, n)
    });
    n(window).bind("resize orientationchange", function(n) {
        t._update(!0, n)
    })
});
runResizing = debounce(function() {
    refineResults()
}, 250);
$("[data-toggle=popover]").popover({
    html: !0,
    content: function() {
        return $("#popover-content").html()
    }
});
$(document).on("click", function(n) {
    $('[data-toggle="popover"],[data-original-title]').each(function() {
        $(this).is(n.target) || $(this).has(n.target).length !== 0 || $(".popover").has(n.target).length !== 0 || ((($(this).popover("hide").data("bs.popover") || {}).inState || {}).click = !1)
    })
});
$("#PlaygroundDDL").on("changed.bs.select", function(n) {
    $('#PlaygroundTabs a[href="#' + n.target.value + '"]').tab("show")
});
if ($(document).ready(function() {
        $(".pin-inner img.pinit-img").hover(function() {
            if ($(this).data("pin-no-hover")) {
                var n = $(this),
                    t = $("span[class^='PIN_']", $(this).parent());
                t.css({
                    left: n.position().left + 10,
                    top: n.position().top + 10
                }).show()
            }
        }, function() {
            var n = $("span[class^='PIN_']", $(this).parent());
            n.hide()
        });
        $(".page-homepage .column-eqh .flat").matchHeight();
        $(".column-eqh:not(.homepage)").matchHeight();
        $(".main-nav-contentarea").hoverIntent(function() {
            var n = $(this);
            n.addClass("onitem");
            $("a:first", n).attr("aria-expanded", "true");
            setTimeout(function() {
                $(".subnavigation-inner-container", n).each(function() {
                    $("h2", $(this)).matchHeight()
                })
            }, 50)
        }, function() {
            $(this).removeClass("onitem");
            $("a:first", $(this)).attr("aria-expanded", "false")
        }, "li");
        $(".main-nav-contentarea").on("keydown", "> li.main-nav__item", function(n) {
            var i;
            if (n.keyCode === 13 || n.keyCode === 32) {
                var t = $(this),
                    r = $("a:first", t),
                    u = $(n.target).closest(".linksblock").length > 0;
                u || (n.preventDefault(), i = $(this).hasClass("onitem"), $(".main-nav-contentarea > li").removeClass("onitem"), $(".main-nav-contentarea > li > a").attr("aria-expanded", "false"), i || (t.addClass("onitem"), r.attr("aria-expanded", "true")))
            }
        });
        window.addEventListener("resize", runResizing);
        viewport().width < 1024 && refineResults();
        viewport().width >= 1024 && $(".desk-main-nav").css("display") === "block" && $("a, area, input, select, textarea, button, iframe, [tabindex], [contentEditable=true]").focus(function() {
            var t = $(window).scrollTop(),
                i = $(document.activeElement).offset().top,
                r = i - t,
                n = 230;
            r < n && $(window).scrollTop($(this).offset().top - n)
        });
        $("a[data-toggle='collapse']").click(function() {
            var n = $(this);
            n.hasClass("collapsed") ? n.attr("aria-expanded", "true") : n.attr("aria-expanded", "false")
        });
    }), $(".video-controls__pause").length > 0) {
    var video = $("#Hero-Video").get(0),
        pauseBtn = $(".video-controls__pause"),
        playBtn = $(".video-controls__play");
    pauseBtn.click(function() {
        video.pause();
        pauseBtn.toggleClass("hide");
        playBtn.toggleClass("hide")
    });
    playBtn.click(function() {
        video.play();
        pauseBtn.toggleClass("hide");
        playBtn.toggleClass("hide")
    })
}